import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Tag, TagCloud } from "../Blog/TagCloud";
import { linkifyText } from "../../utils/linkifyText";

export default function VideoDescription({ video }) {
  return (
    <>
      <div className="single-video-info-content box mb-3">
        {video?.cast && (
          <DescriptionBlock heading="تهیه کنندگان" body={video?.cast} />
        )}

        {video?.categorys?.name && (
          <DescriptionBlock
            heading="دسته بندی"
            body={video?.categorys?.name}
            href={`/videos/${video?.categorys?.id}`}
          />
        )}

        {video?.sub_categorys?.name && (
          <DescriptionBlock
            heading="زیردسته"
            body={video?.sub_categorys?.name}
            href={`/sub-category-videos/${video?.sub_categorys?.id}`}
          />
        )}

        {video?.description && (
          <DescriptionBlock
            heading="درباره"
            body={linkifyText(video.description)}
          />
        )}

        {video?.is_repost && (
          <DescriptionBlock
            heading=""
            body={
              <>
                بازنشر شده از کانال{" "}
                <Link to={`/single-channel/${video?.original_channel?.id}`}>
                  {video?.original_channel?.name}
                </Link>
              </>
            }
          />
        )}

        {video?.is_repost && (
          <DescriptionBlock
            heading=""
            body={
              <>
                ویدئو اصلی{" "}
                <Link to={`/video-page/${video?.original_post_info?.id}`}>
                  {video?.original_post_info?.title}
                </Link>
              </>
            }
          />
        )}

        {video?.tags?.length > 0 && (
          <TagCloud heading="برچسب ها">
            {video?.tags?.map((item, index) => (
              <Tag
                key={index}
                name={item.name}
                href={`/tag-videos/${item?.id}`}
              />
            ))}
          </TagCloud>
        )}
      </div>
    </>
  );
}

function DescriptionBlock({ heading, body, href }) {
  return (
    <>
      <h6>{heading}</h6>
      {href ? (
        <a href={href}>
          <p style={{ whiteSpace: "pre-line" }}>{body}</p>
        </a>
      ) : (
        <p style={{ whiteSpace: "pre-line" }}>{body}</p>
      )}
    </>
  );
}
